
    const data = {"name":"src/core/icons/home-plus","data":{"viewBox":"0 0 24 24","data":"<path pid=\"0\" d=\"M17 14h2v3h3v2h-3v3h-2v-3h-3v-2h3v-3M12 3l10 9h-4a6.005 6.005 0 0 0-5.66 8H5v-8H2l10-9Z\"/>","originalColors":[],"stopColors":[]}}

            export default data
            